export default __webpack_public_path__ + "static/payments-accepted-v2-fcd72d3cb20a0658d09ea78612521e69.png";